import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import {
  UpdateUnavailabilityPeriodRequest,
  UnavailabilityPeriod,
} from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

/**
 * Hook to update an existing unavailability period
 */
export const useUpdateUnavailabilityPeriod = (periodId: string) => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      data: UpdateUnavailabilityPeriodRequest
    ): Promise<UnavailabilityPeriod> => {
      const response = await fetchWithAuth(
        `${URL}/profile/unavailability/${periodId}`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        }
      )
      return response
    },
    onSuccess: () => {
      // Invalidate relevant queries to refetch the data
      queryClient.invalidateQueries({ queryKey: ['unavailabilityPeriods'] })
      queryClient.invalidateQueries({
        queryKey: ['unavailabilityPeriod', periodId],
      })
      toast.success('Unavailability period updated successfully')
    },
    onError: (error) => {
      console.error('Error updating unavailability period:', error)
      toast.error(error.message || 'Failed to update unavailability period')
    },
  })
}
